

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoCoSoLaoDong} from "@/models/baoCaoCoSoLaoDong";
import {ThongTinLaoDong} from "@/models/thongTinLaoDong";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoYTeLaoDongTuyenHuyen} from "@/models/baoCaoYTeLaoDongTuyenHuyen";
import {TongSoMau} from "@/models/tongSoMau";
import {BaoCaoKetQuaHoatDongYTKDThang} from "@/models/baoCaoKetQuaHoatDongYTKDThang";
import {BaoCaoYTeTruongHoc} from "@/models/baoCaoYTeTruongHoc";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoYTeTruongHoc);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const initDb = () => {
      baoCao.value.nguonKinhPhiTrienKhais = [
        {noiDung: "Tuyến tỉnh"},
        {noiDung: "Tuyến huyện"},
        {noiDung: "Tuyến xã"},
      ];
      baoCao.value.quanLySucKhoes = [
        {noiDung: "Mầm non"},
        {noiDung: "Tiểu học"},
        {noiDung: "PTCS"},
        {noiDung: "PTTH"},
        {noiDung: "Trường liên cấp"},
        {noiDung: "Các trường chuyên nghiệp, trường nghề, Trung cấp, cao đẳng, đại học, học viện"},
      ];
      baoCao.value.daoTaoTapHuans = [
        {doiTuongTuyenTinh: "Cán bộ chuyên trách ngành y tế và giáo dục tuyến huyện, xã", doiTuongTuyenHuyen: "Cán bộ chuyên trách ngành y tế và giáo dục tuyến huyện, xã"},
        {doiTuongTuyenTinh: "Nhân viên y tế trong trường học, giáo viên kiêm nhiệm", doiTuongTuyenHuyen: "Nhân viên y tế trong trường học, giáo viên kiêm nhiệm"},
      ];
      baoCao.value.truyenThongGiaoDucSKs = [
        {},
        {},
        {},
      ];
      baoCao.value.dieuKienVeCSVatChats = [
        {noiDung: "Điều kiệnvề phòng học"},
        {noiDung: "Điều kiện về phòng thí nghiệm"},
        {noiDung: "Điều kiện về phòng tin học"},
        {noiDung: "Điều kiện về bàn ghế phòng học"},
        {noiDung: "Điều kiện về bàn ghế phòng thí nghiệm"},
        {noiDung: "Điều kiện về bàn ghế phòng tin học"},
        {noiDung: "Điều kiện về bảng phòng học"},
        {noiDung: "Cường độ chiếu sáng"},
        {noiDung: "Cường độ tiếng ồn"},
        {noiDung: "Điều kiện về thiết bị, đồ chơi trẻ em"},
        {noiDung: "Đủ nước uống"},
        {noiDung: "Đủ nước sinh hoạt"},
        {noiDung: "Khu vực vệ sinh riêng cho học sinh và giáo viên, riêng biệt cho nam và nữ"},
        {noiDung: "Mỗi khu vệ sinh nhà tiêu, nhà tiểu, khu rửa tay có nước sạch, xà phòng hoặc dung dịch sát khuẩn"},
        {noiDung: "Khu vệ sinh đảm bảo hợp vệ sinh"},
        {noiDung: "Nhà tiêu, tiểu đảm bảo về số lượng"},
        {noiDung: "Có hệ thống cống rãnh thoát nước mưa, nước thải sinh hoạt, không có nước ứ đọng xung quanh trường lớp"},
        {noiDung: "Có thùng chứa rác và phân loại rác thải"},
      ];
      baoCao.value.tinhHinhBenhTatTrongNams = [
        {nguyCoSucKhoe: "Mầm non"},
        {nguyCoSucKhoe: "Tiểu học"},
        {nguyCoSucKhoe: "PTCS"},
        {nguyCoSucKhoe: "PTTH"},
        {nguyCoSucKhoe: "Trường liên cấp"},
        {nguyCoSucKhoe: "Các trường chuyên nghiệp, trường nghề, Trung cấp, cao đẳng, đại học, học viện"},
      ];
      baoCao.value.tinhHinhDichBenhTruyenNhiems = [
        {nguyCoSucKhoe: "Mầm non"},
        {nguyCoSucKhoe: "Tiểu học"},
        {nguyCoSucKhoe: "PTCS"},
        {nguyCoSucKhoe: "PTTH"},
        {nguyCoSucKhoe: "Trường liên cấp"},
        {nguyCoSucKhoe: "Các trường chuyên nghiệp, trường nghề, Trung cấp, cao đẳng, đại học, học viện"},
      ];
      baoCao.value.taiNanThuongTichs = [
        {nguyCoSucKhoe: "Mầm non"},
        {nguyCoSucKhoe: "Tiểu học"},
        {nguyCoSucKhoe: "PTCS"},
        {nguyCoSucKhoe: "PTTH"},
        {nguyCoSucKhoe: "Trường liên cấp"},
        {nguyCoSucKhoe: "Các trường chuyên nghiệp, trường nghề, Trung cấp, cao đẳng, đại học, học viện"},
      ];
      baoCao.value.veSinhAnToanTPs = [
        {noiDung: "Nhà ăn, căng tin thông thoáng, đủ ánh sáng, cửa sổ có lưới chống chuột, ruồi nhặng, côn trùng"},
        {noiDung: "Nơi chế biến thức ăn được thiết kế theo nguyên tắc 1 chiều, có đủ dụng cụ chế biến, bảo quản, sử dụng riêng với thực phẩm sống và thức ăn chín"},
        {noiDung: "Dụng cụ chứa thức ăn và sử dụng để ăn uống được làm bằng vật liệu dễ làm vệ sinh và không thôi nhiễm yếu tố độc hại"},
        {noiDung: "Có lưu mẫu thức ăn theo quy định"},
        {noiDung: "Có đủ phương tiện, trang thiết bị phục vụ làm vệ sinh, khử trùng"},
        {noiDung: "Có nguồn nước sạch và chỗ rửa tay với xà phòng hoặc dung dịch sát khuẩn"},
        {noiDung: "Nhân viên nhà bếp, căng tin được tập huấn về an toàn thực phẩm"},
        {noiDung: "Nhân viên nhà bếp, căng tin có giấy chứng nhận sức khỏe theo quy định của Bộ Y tế"},
        {noiDung: "Người trực tiếp làm tại nhà ăn, nhà bếp có mặc trang phục bảo hộ"},
        {noiDung: "Ký hợp đồng với các cơ sở có giấy chứng nhận đủ điều kiện an toàn thực phẩm để cung cấp suất ăn cho học sinh (Trường hợp trường không tự cung cấp suất ăn)"},
      ];
      baoCao.value.tiemChungPhongBenhTaiTruongs = [
        {},
        {},
        {},
      ];
      baoCao.value.truongKhaiCacChuongTrinhYTes = [
        {noiDung: "Phòng chống HIV/AIDS"},
        {noiDung: "Phòng chống tai nạn thương tích"},
        {noiDung: "Phòng chống dịch bệnh truyền nhiễm"},
        {noiDung: "Phòng chống suy dinh dưỡng"},
        {noiDung: "An toàn thực phẩm"},
        {noiDung: "Phòng chống thuốc lá"},
        {noiDung: "Phòng chống rượu bia"},
        {noiDung: "Xây dựng Trường học nâng cao sức khỏe"},
        {noiDung: "Phun hóa chất diệt côn trùng"},
         ];
      baoCao.value.hoaDongTruyenThongGiaoDucs = [
        {noiDung: "Phòng chống dịch, bệnh truyền nhiễm"},
        {noiDung: "Phòng chống ngộ độc thực phẩm"},
        {noiDung: "Dinh dưỡng hợp lý"},
        {noiDung: "Hoạt động thể lực nâng cao sức khỏe"},
        {noiDung: "Phòng chống tác hại thuốc lá"},
        {noiDung: "Phòng chống tác hại rượu bia"},
        {noiDung: "Phòng chống bệnh, tật học đường"},
        {noiDung: "Chăm sóc răng miệng"},
        {noiDung: "Phòng chống các bệnh về mắt"},
        {noiDung: "Phòng chống tai nạn thương tích"},
        {noiDung: "Khác (ghi rõ)"},
      ];
    }
    initDb();
    const addReport = () => {
      if(baoCao.value.tuNam == null || baoCao.value.denNam == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoYTeTruongHoc(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoYTeTruongHoc);
              baoCao.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    return {
      date,
      service,
      baoCao,
      addReport,
    }
  }

}
